import React from "react";

const Divider = () => {
  return <hr className="shortcut-divider"/>
}

export default Divider;